import React from 'react';
import { getApi } from '../../../api/endpoints.js';
import uiManager from '../../../../config/ui.js';
import PAGES from '../../../data/PagesConstants.js';
import ListingPageComponent from '../../../components/ListingPageComponent.js';
import UiAction from '../../../components/UiAction.js';
import UI_ACTIONS from '../../../data/UiActionConstants.js';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faEdit } from '@fortawesome/free-solid-svg-icons';

const Index = () => {
  const defaultHeaderConfig = { disableSort: true };
  const navigate = useNavigate();
  const params = useParams();

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      value: (row) => {
        return <>
          <span className='mx-2'>
            {row.is_active || row.is_active == null ?
            <FontAwesomeIcon icon={faCircle} className="text-success"/> :
            <FontAwesomeIcon icon={faCircle} className="text-danger"/>}
          </span>
          {row.id}
        </>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'Remaining Swaps Greater Than',
      attr: 'remaining_gte',
    },
    {
      ...defaultHeaderConfig,
      label: 'Percentage',
      attr: 'percent',
    },
    {
      ...defaultHeaderConfig,
      label: 'Fixed',
      attr: 'fixed',
    },
    {
      ...defaultHeaderConfig,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.update_rollover_config.name)}>
            <div style={{ cursor: 'pointer' }} onClick={(e) => onEditClick(row.id)}>
              <FontAwesomeIcon icon={faEdit} />
            </div>
          </UiAction>
        </div>
      },
    }
  ]

  const onEditClick = (roll_over_config_id) => {
    navigate(`/fleet_owners/${params.fleet_owner_id}/lease_offers/${params.id}/rollover_configs/${roll_over_config_id}/edit`);
  }

  const tableHeaderActionsComponent = () => {
    return <React.Fragment>
      <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.create_rollover_config.name)}>
        <button className="s-btn me-2" style={{ width: "150px" }} onClick={onNewClick}>
          <span>Add Rollover Config</span>
        </button>
      </UiAction>
    </React.Fragment>
  }

  const onNewClick = () => {
    navigate(`/fleet_owners/${params.fleet_owner_id}/lease_offers/${params.id}/rollover_configs/new`);
  }

  return <ListingPageComponent
    key={PAGES.RolloverConfigsPage.name}
    uiPage={uiManager.getUiPage(PAGES.RolloverConfigsPage.name)}
    breadcrumbs={[
      { label: "Home", url: '/dashboard' },
      { label: "Fleet Owners", url: `/fleet_owners` },
      { label: `${params.fleet_owner_id}`, url: `/fleet_owners/${params.fleet_owner_id}` },
      { label: `Lease Offers`, url: `/fleet_owners/${params.fleet_owner_id}` },
      { label: `${params.id}`, url: `/fleet_owners/${params.fleet_owner_id}` },
      { label: 'Rollover Configurations' }
    ]}
    listingMutation={getApi('rollOverConfigs')}
    className="LeaseOffer-RolloverConfigs-Listing-page"
    contentHeading={`Rollover Configurations For Lease Offer - Results`}
    headers={headers}
    recordsKey="rollover_configs"
    searchBy={['ID']}
    tableHeaderActionsComponent={tableHeaderActionsComponent()}
    filtersModel={{configurable_type: "LeaseOffer", configurable_id: params.id}}
  />
};

export default Index;
